import { useMemo } from 'react';

/**
 * Derive the union of plant IDs across every plant-aware section of a Material
 * Master form. Replaces a `useEffect + useState + setSelectedPlants` pattern
 * that previously triggered ESLint's "useEffect dependencies above threshold"
 * warning.
 *
 * Returns a stable array (memoized).
 */
export const useSelectedPlants = (formData) => {
  return useMemo(() => {
    const plants = new Set();
    if (!formData) return [];

    if (Array.isArray(formData.sales_data)) {
      formData.sales_data.forEach((sd) => sd?.plant_id && plants.add(sd.plant_id));
    }
    if (formData.mrp?.plant_id) plants.add(formData.mrp.plant_id);
    if (formData.forecasting?.plant_id) plants.add(formData.forecasting.plant_id);
    if (formData.production_resources_tools?.plant_id) {
      plants.add(formData.production_resources_tools.plant_id);
    }

    const pds = formData.plant_data_storage;
    if (Array.isArray(pds)) {
      pds.forEach((pd) => pd?.plant_id && plants.add(pd.plant_id));
    } else if (pds?.plant_id) {
      plants.add(pds.plant_id);
    }

    if (formData.accounting?.plant_id) plants.add(formData.accounting.plant_id);

    return Array.from(plants);
  // eslint-disable-next-line
  }, [
    formData?.sales_data,
    formData?.mrp,
    formData?.forecasting,
    formData?.production_resources_tools,
    formData?.plant_data_storage,
    formData?.accounting,
  ]);
};
